import { render, staticRenderFns } from "./InsuranceContent.vue?vue&type=template&id=829b2a76&scoped=true&"
import script from "./InsuranceContent.vue?vue&type=script&lang=js&"
export * from "./InsuranceContent.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceContent.vue?vue&type=style&index=0&id=829b2a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829b2a76",
  null
  
)

export default component.exports